<template>
  <div class="main_right">
    <div class="page_info">
      <Breadcrumb class="breadcrumb">
        <BreadcrumbItem>操作日志</BreadcrumbItem>
      </Breadcrumb>
      <div class="searchBox">
        <DatePicker type="datetimerange" :value="dataVal" :editable="false" format="yyyy-MM-dd HH:mm:ss" placeholder="请选择日期时间" style="width: 300px" @on-change="changeData($event)" @on-ok="changeDataGetPage()"></DatePicker>
        <div>
          <Input v-model="reqbody.searchKey" icon="ios-search" placeholder="操作员/操作内容" style="width: 200px" @on-click="search" @keyup.13.native="search"/>
          <Button type="ghost" @click="exportLog" v-if="authList.indexOf('005001') !== -1">导出</Button>
        </div>
      </div>

      <Table border height="520" ref="log_table" :columns="columns" :data="tableData"></Table>
      <page :total="total" show-sizer class="table_page" @on-change="changePageNo" @on-page-size-change="changePageSize" show-total></page>
    </div>
  </div>
</template>

<script>
import {httpUrl} from '../../api'
import TopOpe from '../top-ope/top-ope'
import {errorHandler} from '../../util/errorHandler'
import {getAuthStr} from '../../util/bus'

export default {
  components: {TopOpe},
  name: 'log-page',
  data () {
    return {
      authList: '',
      dataVal: [],
      reqbody: {
        searchKey: '',
        startTime: '',
        endTime: '',
        pageSize: 10,
        pageNo: 1
      },
      columns: [{
        title: '操作员',
        key: 'operator',
        align: 'center'
      }, {
        title: '操作事件',
        key: 'operateEvent',
        align: 'center'
      }, {
        title: '操作内容',
        key: 'description',
        align: 'center'
      }, {
        title: '发生时间',
        key: 'operateTime',
        align: 'center'
      }],
      tableData: [],
      total: 0
    }
  },
  created () {
    this.authList = getAuthStr()
    this.getTime()
    this.getLogPage()
  },
  methods: {
    exportLog () {
      let exportUrl = `${httpUrl.url}/manage/logOper/export?searchKey=${this.reqbody.searchKey}&startTime=${this.reqbody.startTime}&endTime=${this.reqbody.endTime}`
      this.downloadFile('', exportUrl)
    },
    downloadFile (fileName, href) {
      let eleLink = document.createElement('a')
      eleLink.download = fileName
      eleLink.style.display = 'none'
      eleLink.href = href
      eleLink.click()
    },
    getTime () {
      let date = new Date()
      let seperator1 = '-'
      let seperator2 = ':'
      let month = date.getMonth() + 1
      let strDate = date.getDate()
      let strHours = date.getHours()
      let strMin = date.getMinutes()
      let strSec = date.getSeconds()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      if (strHours >= 0 && strHours <= 9) {
        strHours = '0' + strHours
      }
      if (strMin >= 0 && strMin <= 9) {
        strMin = '0' + strMin
      }
      if (strSec >= 0 && strSec <= 9) {
        strSec = '0' + strSec
      }
      let edate = date.getFullYear() + seperator1 + month + seperator1 + strDate + ' ' + strHours + seperator2 + strMin + seperator2 + strSec
      let sdate = date.getFullYear() + seperator1 + month + seperator1 + strDate + ' ' + '00' + seperator2 + '00' + seperator2 + '00'
      this.dataVal = [sdate, edate]
    },
    getLogPage () {
      if (this.dataVal.length !== 0) {
        this.reqbody.startTime = this.dataVal[0]
        this.reqbody.endTime = this.dataVal[1]
      }
      this.$axios.post(`${httpUrl.url}/manage/logOper/getPage`, this.reqbody)
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data
            this.tableData = data.list
            this.total = data.total
          }
        })
        .catch(errorHandler('获取数据失败'))
    },
    changeData ($event) {
      this.dataVal = $event
    },
    changeDataGetPage () {
      this.getLogPage()
    },
    changePageNo (m) {
      this.reqbody.pageNo = m
      this.getLogPage()
    },
    changePageSize (n) {
      this.reqbody.pageSize = n
      this.getLogPage()
    },
    search () {
      this.reqbody.pageNo = 1
      this.getLogPage()
    }
  }
}
</script>

<style scoped>
  .main_right {
    min-width: 780px;
    height: 100%;
  }

  .breadcrumb {
    margin-bottom: 10px;
    border-left: 3px solid #00A0E6;
    padding-left: 5px;
  }

  .page_info {
    margin: 15px;
    background-color: #fff;
  }
  .searchBox {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  .table_page {
    text-align: right;
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/log/log-page.vue